import * as THREE from "three";

export function toNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function normalizeAxis(axis = {}) {
  const v = new THREE.Vector3(
    toNumber(axis.x, 0),
    toNumber(axis.y, 0),
    toNumber(axis.z, 1)
  );

  if (v.lengthSq() < 0.000001) {
    return new THREE.Vector3(0, 0, 1);
  }

  return v.normalize();
}

export function createEmptyDrill() {
  return {
    id: `drill_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    name: "New drill",
    kind: "blind", // blind | through
    diameter: 5,
    depth: 10,
    start: { x: 0, y: 0, z: 0 },
    axis: { x: 0, y: 0, z: 1 },
    color: "#3b82f6",
    enabled: true,
  };
}

export function getDrillEnd(drill) {
  const start = new THREE.Vector3(
    toNumber(drill?.start?.x, 0),
    toNumber(drill?.start?.y, 0),
    toNumber(drill?.start?.z, 0)
  );

  const axis = normalizeAxis(drill?.axis);
  const depth = toNumber(drill?.depth, 0);

  return start.clone().add(axis.multiplyScalar(depth));
}